export default "https://cdn-static.gokick.com/assets/6600ddf3ffcd3e3653ecf6807c0977bcbaa0931f/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";